import { useTranslation } from "react-i18next";
import React, { useEffect, useState } from "react";
import { LearningOutcomesService } from "../../services/LearningOutcomesService";
import { Selector } from "../Selectors/Selector";

export const LearningOutcomesTypeSelect = ({
  selectHandler,
  selectedOutcomeTypeId,
  subjects,
  trigger,
  program,
  assessmentFlag,
  size,
  forInstitutionalAssessment,
  forExternalAssessment,
  width,
}) => {
  const { t } = useTranslation();
  const [loTypes, setLoTypes] = useState([]);
  const [interaction, setInteraction] = useState(true);

  useEffect(() => {
    const type_arr = [];
    if (program.length === 0 && !forInstitutionalAssessment) {
      setInteraction(false);
    } else {
      setInteraction(true);
      LearningOutcomesService.getLearningOutcomeTypes(
        forExternalAssessment
      ).then((learningOutcomeTypes) => {
        if (forInstitutionalAssessment) {
          learningOutcomeTypes.forEach((type) => {
            if (type.name === "ILO" || type.name === "CLO") {
              type_arr.push({ id: type.id, label: type.name });
            }
          });
        } else if (assessmentFlag) {
          learningOutcomeTypes.forEach((type) => {
            type_arr.push({ id: type.id, label: type.name });
          });
        } else {
          learningOutcomeTypes.forEach((type) => {
            if (type.name === "PSLO") {
              // FIX THIS. Maybe it should just always be both PSLO and ISLO and control elsewhere, or we could pass in Program ID array
              LearningOutcomesService.getLearningOutcomesByType(
                "pslo",
                subjects
              ).then((pslos) => {
                if (pslos.length === 0) {
                  return;
                } else {
                  if (!type_arr.includes({ id: type.id, label: type.name })) {
                    type_arr.push({ id: type.id, label: type.name });
                  }
                }
              });
            } else {
              if (!type_arr.includes({ id: type.id, label: type.name })) {
                type_arr.push({ id: type.id, label: type.name });
              }
            }
          });
        }
      });
      setLoTypes(type_arr);
    }
  }, [program, assessmentFlag, forInstitutionalAssessment, subjects]);

  return (
    <Selector
      id="learning-outcome-type-selector"
      options={loTypes}
      selectHandler={selectHandler}
      size={size}
      label={t("learningOutcomes.typeSelectorRequired")}
      selectedItemId={selectedOutcomeTypeId ? selectedOutcomeTypeId : ""}
      interaction={interaction}
      clear={trigger}
      width={width}
    />
  );
};
